//
// Action types
//

export const SET_MAP_TITLE = "SET_MAP_TITLE";
export const REMOVE_MAP_TITLE = "REMOVE_MAP_TITLE";

//
// Action creators
//

export function setMapTitle(mapKey) {
  return {
    type: SET_MAP_TITLE,
    mapKey
  };
}

export function removeMapTitle(mapKey) {
  return {
    type: REMOVE_MAP_TITLE,
    mapKey
  };
}

function setMapTitleHandler() {
  return true;
}

function removeMapTitleHandler() {
  return false;
}

//
// Reducer and handlers
//

export function reduceMapTitle(state, action) {
  switch (action && action.type) {
    case SET_MAP_TITLE:
      return setMapTitleHandler();

    case REMOVE_MAP_TITLE:
      return removeMapTitleHandler();

    default:
      return state || false;
  }
}
